import React, { useRef, useEffect } from "react";
import { NumericFormat } from "react-number-format";
import { Field } from "formik";
import { FormControl, FormLabel, Box, FormErrorMessage } from "@chakra-ui/react";
import "./style.scss";

const PercentageSpc = ({
  inputName,
  labelName,
  input,
  setInput,
  center,
  readOnly,
  removeBorder,
  inputRef,
  onBlur,
  onFocus,
  allowNegative = true,
  suffix = "%",
}) => {
  const myInputRef = useRef(null);

  useEffect(() => {
    if (input !== undefined && input !== null) {
      setInput(input);
    }
  }, [input]);

  const clearFormatting = (val) => {
    let inputValue = parseFloat(val.replace("%", "").replace(",", "."));
    return isNaN(inputValue) ? 0 : inputValue;
  };

  function handleFocusOnLastIndex() {
    const length = myInputRef.current.value.length;
    if (myInputRef.current.setSelectionRange) {
      myInputRef.current.setSelectionRange(length, length);
    }
  }

  const handleKeyDown = (e) => {
    const val = myInputRef.current.value;
    const { key, keyCode } = e;

    // Tratamento para teclados móveis
    if ((key === '-' || keyCode === 229) && allowNegative) {
      e.preventDefault();
      const newVal = clearFormatting(val);
      setInput(-newVal);
      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    } else if (!isNaN(parseInt(key))) {
      e.preventDefault();
      const inputValue = clearFormatting(val);
      let [inteiro, decimal] = String(inputValue).split(".");
      const isNegativeZero = Object.is(inputValue, -0);
      inteiro += (decimal?.[0] || 0);
      decimal = (decimal?.[1] || 0) + key;
      const parsedValue = parseFloat(`${isNegativeZero ? "-" : ""}${inteiro}.${decimal}`);
      setInput(parsedValue);
      setTimeout(() => {
        handleFocusOnLastIndex();
      }, 1);
    }
  };

  return (
    <Field name={inputName}>
      {({ field, meta }) => (
        <FormControl isInvalid={meta.error && meta.touched}>
          {labelName && <FormLabel className="field__label">{labelName}</FormLabel>}
          <Box position="relative">
            <NumericFormat
              className={`percentage-input search-wrapper w-full h-[50px] searchWrapper text-[1rem] ${
                center && "text-center"
              } ${removeBorder && "remove-border"}`}
              suffix={suffix}
              decimalScale={2}
              decimalSeparator=","
              fixedDecimalScale
              allowNegative={allowNegative}
              onFocus={(e) => {
                if (typeof onFocus === "function") onFocus(e);
                handleFocusOnLastIndex();
              }}
              {...field}
              value={input}
              onKeyDown={handleKeyDown}
              onChange={(e) => {
                const inputValue = clearFormatting(e.target.value);
                setInput(inputValue);
              }}
              readOnly={readOnly}
              getInputRef={myInputRef}
              ref={inputRef}
              onBlur={onBlur}
            />
          </Box>
          {meta.touched && meta.error && <FormErrorMessage>{meta.error}</FormErrorMessage>}
        </FormControl>
      )}
    </Field>
  );
};

export default PercentageSpc;